module.exports = __webpack_public_path__ + "img/showMemory.e5f66950.svg";